<template>
	<div
		class="w-max rounded-full px-2 text-sm font-bold text-white"
		:style="{
			backgroundColor: TaskTypeConfigs[type].color,
			color: TaskTypeConfigs[type].contrastColor,
		}"
	>
		{{ t(TaskTypeConfigs[type].name) }}
	</div>
</template>

<script setup lang="ts">
	import {
		TaskType,
		TaskTypeConfigs,
	} from "seedgreen-shared/dtos/TaskTypeConfig";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();

	interface Props {
		type: TaskType;
	}
	defineProps<Props>();
</script>
